export interface Theme {
  name: string;
  properties: any;
}

export const light: Theme = {
  name: 'light',
  properties: {
    // '--app-color-primary': '#B9083E',
    '--app-color-primary': '#0077B0',
    '--app-color-primary-tint': '#B9083EBA',
    '--app-color-secondary': '#000',
    '--app-color-secondary-tint': '#ccc',
    '--app-color-tertiary': '#767676',
    '--app-color-tertiary-tint': '#9c8d91',
    '--app-color-danger': '#F83D3C',
    '--app-background-primary': '#fff',
    '--app-background-primary-tint': '#b1b1b1',
    '--app-color-table-row': '#000'
  }
};

export const dark: Theme = {
  name: 'dark',
  properties: {
    '--app-color-primary': '#B9083E',
    '--app-color-primary-tint': '#B9083EBA',
    '--app-color-secondary': '#fff',
    '--app-color-secondary-tint': '#ccc',
    '--app-color-tertiary': '#fff',
    '--app-color-tertiary-tint': '#968282',
    '--app-color-danger': '#F83D3C',
    '--app-background-primary': '#222b45',
    '--app-background-primary-tint': '#1d2438',
    '--app-color-table-row': '#000'
  }
};

